/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

document.addEventListener('DOMContentLoaded', () => {
  const updateSwatchCounts = () => {
    document.querySelectorAll('[data-swatch-count]').forEach((el) => {
      const product = el.closest('.product-item');
      if (!product) return;

      // Find the grid-swatch element which contains full colour data
      const gridSwatch = product.querySelector('grid-swatch[data-swatch-values]');
      if (!gridSwatch) return;

      const swatchData = gridSwatch.getAttribute('data-swatch-values');
      if (!swatchData) return;

      // Example: "Arctic Blue:arctic-blue,Army:army,Atlantic:atlantic,Autumn:autumn"
      // Split by comma to get each "Colour:handle" pair
      const colourPairs = swatchData.split(',').map(v => v.trim()).filter(Boolean);

      // Get only the colour names before the colon
      const colourNames = colourPairs.map(pair => pair.split(':')[0].trim().toLowerCase());

      // Remove duplicates just in case
      const uniqueColours = new Set(colourNames);
      const colourCount = uniqueColours.size;

      // Update label
      const label = `${colourCount} ${colourCount === 1 ? 'colour' : 'colours'}`;
      el.textContent = label;
    });
  };

  // Run on load
  updateSwatchCounts();

  // Run again for lazy loaded grids
  setTimeout(updateSwatchCounts, 1000);
  setTimeout(updateSwatchCounts, 2500);

  // Run when Shopify sections reload
  ['shopify:section:load', 'shopify:section:reorder', 'shopify:section:select', 'shopify:section:deselect']
    .forEach(evt => document.addEventListener(evt, updateSwatchCounts));

  // Watch for dynamic inserts (infinite scroll, filters, quick add, etc.)
  const targetNode = document.querySelector('#CollectionGrid, .collection-grid, .grid') || document.body;
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if ([...m.addedNodes].some(node => node.nodeType === 1 && node.querySelector?.('[data-swatch-count]'))) {
        updateSwatchCounts();
        break;
      }
    }
  });
  observer.observe(targetNode, { childList: true, subtree: true });
});



  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
